import { arrayOf } from 'prop-types';

import GenericStore from '../classes/generic-store';
import { getOpportunityPositions } from '../api/opportunity-legacy-api';
import { positionShape } from '../models/position';
import { PositionUtil } from '../utils/position-util';

class OpportunityPositionsStoreClass extends GenericStore {
  load(opportunityId) {
    return this.setState(
      // name isn't initially filled in
      getOpportunityPositions(opportunityId).then(PositionUtil.sortPositions)
    );
  }

  getDataShape() {
    return arrayOf(positionShape);
  }

  selectData(state) {
    return this.select(state)?.data || [];
  }
}

export const OpportunityPositionsStore = new OpportunityPositionsStoreClass();
